import * as React  from 'react';
import { ActorAvatar, ActorName } from './actor';
import { combinedViewTime } from './dateKey';
import CombinedViewFiles from './combinedViewFiles';

/**
 * A file attached to the Workkard.
 *
 * This is now a standalone entry rather than a strip hanging off whichever
 * note or log happened to share its timestamp, so it no longer has to fetch
 * the file list and hide itself until the response lands.
 */
export default function WorkkardFilesTemplate({ data, isPrintPreview }) {
    if (!data.files || data.files.length === 0) {
        return null;
    }
    return (
        <div className="combinedListing detailListing">
            <span className="time_line_bar"></span>
            <div className="combinedCreatedDate detailCreatedDate">
                <ActorAvatar userId={data.actor_id} />
            </div>
            <div className="combinedRightBlock detailRightBlock resolutionChanged">
                <div className="combinedDescription detailDescription">
                    <div className="alignMiddle mb mb__8 flexWrap">
                        <ActorName userId={data.actor_id} inner="header" />
                        <span className="dateTime mr">
                            <label className="mrNone">{combinedViewTime(data.occurred_at)}</label>
                        </span>
                        attached a file to this workkard
                    </div>
                    <div className="update_information">
                        <CombinedViewFiles files={data.files} entry={data} isPrintPreview={isPrintPreview} />
                    </div>
                </div>
            </div>
        </div>
    )
}
